import { IconMapCar16, IconMapWalk16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import type { IUnderground } from '../../types/newbuildingRecommendations';
import { UndergroundIcon } from '../NewbuildingRecommendations/Underground/components/UndergroundIcon';
import * as styles from './NewbuildingLocation.css';

type TNewbuildingLocationProps = {
  underground?: IUnderground | null;
  address?: string | null;
};

function getUndergroundColor(lineColor: string) {
  return lineColor.startsWith('#') ? lineColor : `#${lineColor}`;
}

export const NewbuildingLocation: React.FC<TNewbuildingLocationProps> = ({ underground, address }) => {
  if (underground) {
    const TravelIcon = underground.transportType === 'walk' ? IconMapWalk16 : IconMapCar16;

    return (
      <div className={styles['container']}>
        <div className={styles['station']}>
          {underground.lineColor && (
            <span className={styles['icon']}>
              <UndergroundIcon
                color={getUndergroundColor(underground.lineColor)}
                undergroundType={underground.undergroundType}
              />
            </span>
          )}
          <span className={styles['name']}>{underground.undergroundName}</span>
        </div>
        {underground.distance && underground.transportType && (
          <span className={styles['travel-time']}>
            <TravelIcon display="block" color="icon-secondary-default" />
            <span>{underground.distance}</span>
          </span>
        )}
      </div>
    );
  }

  if (!address) {
    return null;
  }

  return <div className={styles['address']}>{address}</div>;
};
